import { Component, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { AuthService } from '../services/auth.service';
import packageJson from '../../../package.json';
import { HttpClient, HttpHeaders } from '@angular/common/http';
declare const $: any;

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [
    {
        path: '/control-tower/alerts',
        title: 'Alerts',
        type: 'link',
        icontype: 'notification_important'
    }, {
        path: '/control-tower/temperatures',
        title: 'Temperatures Alerts',
        type: 'link',
        icontype: 'device_thermostat'
    }, {
        path: '/control-tower/load',
        title: 'Loads',
        type: 'link',
        icontype: 'trending_up'
    }, {
        path: '/control-tower/operations',
        title: 'Operations',
        type: 'link',
        icontype: 'dashboard'
    }, {
        path: '/control-tower/driver',
        title: 'Driver',
        type: 'link',
        icontype: 'local_shipping'
    }, {
        path: '/control-tower/widget-settings',
        title: 'Widget Settings',
        type: 'link',
        icontype: 'settings'
    }, {
        path: '/control-tower/release-notes',
        title: 'Release Notes',
        type: 'link',
        icontype: 'note'
    }

];
@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})

export class SidebarComponent implements OnInit {
    theme = atob(localStorage.getItem('encodedTenant')).toLowerCase();
    currentTenant = atob(localStorage.getItem('encodedTenant')).toUpperCase();
    currentEnv = atob(localStorage.getItem('encodedEnv'))

    cellaClient: string;
    public menuItems: any[];
    ps: any;
    appVersion: string;
    emblemSrc: string;
   

    constructor(private authService: AuthService, private http: HttpClient) {

    }
    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    ngOnInit() {
        this.appVersion = packageJson.version;
        this.getCellaClientURL();
        this.menuItems = ROUTES.filter(menuItem => menuItem);
        this.checkTemperatureData();
        // compute emblem source; if theme is default, point to remote sgconv QA emblem
        this.emblemSrc = '../../assets/theme/' + this.theme + '/emblem.png';
        if (this.theme === 'default') {
            this.emblemSrc = 'https://sgconveniencecontroltowerqa.cella.co.za/assets/theme/sgconv/emblem.png';
        }
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            this.ps = new PerfectScrollbar(elemSidebar);
        }
    }

    getCellaControlTowerApiURL() {
         if( this.currentEnv === 'qa') {
        return `https://${this.currentTenant}controltowerapiqa.cella.co.za`
      } else if (this.currentEnv === 'development') {
        return `https://${this.currentTenant}controltowerapidev.cella.co.za`
      } else {
        return `https://${this.currentTenant}controltowerapi.cella.co.za`
      }
    }
  
      checkTemperatureData() {
        const headers: HttpHeaders = new HttpHeaders({
          Authorization: 'Basic dXNlcjo1QiEqOTcxTWpjQiFXJCU0dXRL'
        });
        
        this.http.get(this.getCellaControlTowerApiURL() +'/api/widgets/section/TEMPERATURES/tenantCode/' + this.currentTenant, { headers }).subscribe((values: any[]) => {
           if (!values || values.length === 0) {
             this.menuItems = this.menuItems.filter(item => item.title !== 'Temperatures Alerts');
           }
        }, (err) => {
            console.error('Error checking temperature data', err);
            this.menuItems = this.menuItems.filter(item => item.title !== 'Temperatures Alerts');
        });
      }

    getCellaClientURL() {
        if(this.currentEnv === 'qa') {
          this.cellaClient = `https://qa.cella.co.za/`
        } else if (this.currentEnv === 'qa') {
            this.cellaClient =`https://dev.cella.co.za/`
        } else{ 
          this.getCellaClientURLByTenant();
        }
      }

    getCellaClientURLByTenant() {
        switch (this.currentTenant) {
            case 'SGCONV':
                this.cellaClient = 'https://sgconvenience.cella.co.za';
                break;
            case 'SGFRGT':
                this.cellaClient = 'https://freight.cella.co.za';
                break;
            case 'SGCONS':
                this.cellaClient = 'https://sgconsumer.cella.co.za';
                break;
            case 'ALMAYA':
                this.cellaClient = 'https://almaya.cella.co.za';
                break;
            case 'LIEBEN':
                this.cellaClient = 'https://lieben.cella.co.za';
                break;
        
            default:
                'SGCONV'
                this.cellaClient = 'https://sgconvenience.cella.co.za';
                break;
        }
    }  
    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            this.ps.update();
        }
    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }

    logout() {
        this.authService.logout();
    }

    onEmblemError(event: Event) {
        const img = event && (event.target as HTMLImageElement);
        if (img) {
            img.src = '../../assets/theme/' + this.theme + '/logo.png';
        }
    }
}
// viewpaletholding
